export default {
  BRAND: 'KMV',
  SITE_NAME: 'Portal Parceiros',
  LOGO_URL: '/assets/imgs/logo_transparent.png'
}
